import { Injectable, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { OptionNotification } from '../../shared/notifications/optionNotification';
import { TypeNotification } from '../../shared/notifications/typeNotification.enum';
import { NavigationService } from '../utilities/navigation.service';
import { IdentityService, RolesEnum } from '../authentication/identity.service';
import { RouterEnum } from '../enum/navigation/router.enum';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  private readonly _identityService = inject(IdentityService);
  private readonly _navigationService = inject(NavigationService);
  private readonly _translateService = inject(TranslateService);

  /**
   *
   * @deprecated Please use  showSuccessMessage || showHttpErrorMessage || showInternalErrorMessage --Remove method when no used
   */
  showNotification(options: OptionNotification) {
    try {
      this.showNotificationAsync(options);
    } catch (err) {
      console.warn('Notificaciones desactivadas', err);
    }
  }
  /**
   *
   * @deprecated Please use  showSuccessMessage || showHttpErrorMessage || showInternalErrorMessage --Remove method when no used
   */
  showNotificationAsync(options: OptionNotification) {
    try {
      const title = this._translateService.instant(options.Title);
      const message = String(options.Message).trim();
      const type = options.Type.toString();
      
      // Log to console as fallback when toast service is not available
      console.log(`[${type.toUpperCase()}] ${title}: ${message}`);
    } catch (err) {
      console.warn('Notificaciones desactivadas', err);
    }
  }

  showSuccessMessage(title: string, message: string) {
    this.showNotificationAsync({
      Title: title ? this._translateService.instant(title) : '',
      Message: message ? this._translateService.instant(message) : '',
      Type: TypeNotification.success,
      CloseOther: false,
      ShowCloseButton: true
    });
  }
  showInfoMessage(title: string, message: string) {
    this.showNotificationAsync({
      Title: title ? this._translateService.instant(title) : '',
      Message: message ? this._translateService.instant(message) : '',
      Type: TypeNotification.info,
      CloseOther: false,
      ShowCloseButton: true
    });
  }
  showProgrammedNotifications(title: string, message: string){
    this.showNotificationAsync({
      Title: this._translateService.instant(title),
      Message: message,
      Type: TypeNotification.info,
      CloseOther: false,
      ShowCloseButton: true,
      Timeout: 0
    });
  }

  /**
   * Common Errors:
   * status == 0 || 403 : Ha ocurrido un problema de conexión
   * status == 400 : Los datos enviados no son correctos
   * status == 401 : http error response
   * status == 404 : No se puede conectar con el servidor
   * status == 500 : Ocurrio un error en el servidor
   */
  showHttpErrorMessage(title: string, error: HttpErrorResponse) {
    if (error.status === 401) {
      title = 'Sesión';
      let rol = this._identityService.rol;
      setTimeout(() => {
        this._identityService.logOut().subscribe(result => {

          switch (this._identityService.rol) {
              case RolesEnum.ROLE_ADMIN:
                this._navigationService.navigate(RouterEnum.loginAdmin);
                  break;
              case RolesEnum.ROLE_CARRIER_ADMINISTRATIVE:
              case RolesEnum.ROLE_CARRIER_MANAGER:
              case RolesEnum.ROLE_CARRIER_OPERATOR:
              case RolesEnum.ROLE_CARRIER:
                this._navigationService.navigate(RouterEnum.loginCarrier);
                  break;
              case RolesEnum.ROLE_CONTRACTOR_OPERATOR:
              case RolesEnum.ROLE_CONTRACTOR_SECRETARY:
              case RolesEnum.ROLE_CONTRACTOR_ADMINISTRATIVE:
              case RolesEnum.ROLE_CONTRACTOR_MANAGER:
              case RolesEnum.ROLE_CONTRACTOR:
                this._navigationService.navigate(RouterEnum.loginContractor);
                  break;
              default:
          }
        });
      }, 1000);
    }
    this.showNotificationAsync({
      Title: title ? this._translateService.instant(title) : '',
      Message:
        error !== null
          ? error.status === 0
            ? this._translateService.instant('toast.shared.error_code.0')
            : error.status === 401
            ? this._translateService.instant('toast.shared.error_code.401')
            : error.status === 402
            ? this._translateService.instant('toast.shared.error_code.402')
            : error.status === 400
            ? this._translateService.instant('toast.shared.error_code.400')
            : error.status === 500
            ? this._translateService.instant('toast.shared.error_code.500')
            : error.status === 404
            ? this._translateService.instant('toast.shared.error_code.404')
            : error.status === 403
            ? this._translateService.instant('toast.shared.error_code.403')
            : error.status === 409 && error.error && error.error.errorCode == 'MERCADOPAGO_IN_USE'
            ? this._translateService.instant('toast.epayments.mercadopago.message.MERCADOPAGO_IN_USE')
            : error.message != null
            ? error.message
            : error.message != null
            ? error.message
            : error.error != null
            ? error.error.message != null
              ? error.error.message
              : error
            : error
          : error,
      Type:
        error.status === 401 ? TypeNotification.info : TypeNotification.error,
      CloseOther: false,
      ShowCloseButton: true
    });
  }
  showInternalErrorMessage(title: string, message: string) {
    this.showNotificationAsync({
      Title: title ? this._translateService.instant(title) : '',
      Message: message ? this._translateService.instant(message) : '',
      Type: TypeNotification.error,
      CloseOther: false,
      ShowCloseButton: true
    });
  }

  showErrorMessage(title: string, message: string){
    this.showNotificationAsync({
      Title: title,
      Message: message,
      Type: TypeNotification.error,
      CloseOther: false,
      ShowCloseButton: true,
      Timeout: 0
    });
  }
}
